import { render } from "./PaymentOutcomeLegacyRedirect.vue?vue&type=template&id=032f07fe"
import script from "./PaymentOutcomeLegacyRedirect.vue?vue&type=script&lang=js"
export * from "./PaymentOutcomeLegacyRedirect.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__